import { HeadModul, ModulContainer } from 'components/Main/table/TableStyles';
import { Modal } from './Header/AddCampaignModal';
import { IoMdClose } from 'react-icons/io';
import { FormInputContainer } from './Header/FormInput';
import { useCampaignContext } from 'context/CampaignContext';
import DatePicker from 'react-datepicker';
import { DarkButton } from 'components/style/Global';
import React, { useState } from 'react';
import { SubContainer } from './Main/Summary/Summary';
import styled from 'styled-components';
import { SingleColumn } from 'components/newSetup/OVERWRITE_DATA/OverwriteMain.Styles';
import { CustomSelect } from 'components/Header/CampaignSelectComponent';
import { datatype, filtertype, SaveCustomReportMutation, SaveCustomReportMutationVariables, UserQuery } from 'API';
import { saveCustomReport } from 'graphql/mutations';
import { API } from 'aws-amplify';
import { getEndDate, getStartDate } from 'methods/dateMethods';
import { useCustomReportContext } from 'context/CustomReportContext';
import {
  useSaveNewSection,
  useSaveNewSectionItem,
  useGetCustomReportSections,
} from './CustomReports/CustomReportsHooks/useCustomReportsGrid';
import { useGetSavedText, useSaveCustomReportText } from './CustomReports/CustomReportsHooks/useCustomReportsText';
import { useGetKPIValues, useSaveCustomReportKPI } from './CustomReports/CustomReportsHooks/useCustomReportsKPI';
import {
  useGetStoredQuery,
  useSaveCustomReportQuery,
  useDuplicateQuery,
  DuplicateQueryFilters,
  fetchCampaignsInDateRange,
} from './CustomReports/CustomReportsHooks/useCustomReportsQueries';
import { useGetStoredFile } from './CustomReports/CustomReportsHooks/useCustomReportsFile';
import {
  useGetStoredCreativeByReportId,
  useSaveCustomReportCreativeForDuplication,
} from './CustomReports/CustomReportsHooks/useCustomReportsCreative';
import { saveFiletoS3 } from './Main/Brief/UploadFile/saveFiletoS3';
import APIContext from 'context/APIContext';
import ReactLoading from 'react-loading';
import { useTheme } from 'styled-components';
import { useLoggingActivity } from 'customHooks/useLogging';
import { useCustomReportId } from 'customHooks/useParameters';

type Props = {
  setDuplicateModal: (value: boolean) => void;
};

export type CampaignPeriodValues = {
  customReportName: string;
  startDate: string;
  endDate: string;
  clientCode?: string;
  campaigns?: string[];
  filterName?: string;
};

const StyledLabel = styled.label`
  cursor: pointer;
  background: transparent;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 7px;
  width: 100%;
  margin-bottom: 8px;
  font-family: 'FontMedium', sans-serif;
  color: ${({ theme }) => theme.primaryGray};
  display: flex;
  margin-bottom: 0.24vw;

  .inputCircle {
    display: none;
  }
  .checked {
    padding: 0.47vw 0.63vw;
    span {
      font-size: 0.73vw;
      font-family: 'FontMedium';
      font-weight: normal;
      color: ${({ theme }) => theme.primaryGray};
      word-wrap: break-word;
    }
    .styleToFit {
      font-size: 12px;
      font-family: 'fontRegular';
      width: 100%;
      z-index: 0;
    }
  }

  input:checked ~ .checked {
    background-color: ${({ theme }) => theme.border};
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border-radius: 7px;
    width: 100%;
  }
`;

const FilterTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1vw;
  margin-top: 1vw;
  padding: 1vw;
  border-radius: 7px;
  border: 1px solid ${({ theme }) => theme.border};
`;

const DuplicatingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 100;
  border-radius: 12px;

  .progress-text {
    margin-top: 16px;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryGray};
    text-align: center;
  }

  .progress-detail {
    margin-top: 8px;
    font-size: 12px;
    color: ${({ theme }) => theme.secondaryGray};
  }
`;

const DuplicateCustomReportModal = (props: Props) => {
  const { setDuplicateModal } = props;
  const { reducedClientList, permanentCampaignList } = useCampaignContext();
  const { activeCustomReport, sectionLayoutState } = useCustomReportContext();
  const { getEnvironment } = React.useContext(APIContext);
  const theme = useTheme();
  const logActivity = useLoggingActivity();
  const [, setCustomReportId] = useCustomReportId();

  // Initialize with source report values
  const sourceFilterType = activeCustomReport?.Filters?.[0]?.column === 'date' ? 'date' : 'campaigns';
  const initialValues: CampaignPeriodValues =
    sourceFilterType === 'date'
      ? {
          customReportName: `${activeCustomReport?.CustomReportName || ''} (Copy)`,
          filterName: sourceFilterType,
          startDate: (activeCustomReport?.Filters?.[0]?.filter?.from as string) || '',
          endDate: (activeCustomReport?.Filters?.[0]?.filter?.to as string) || '',
          clientCode: activeCustomReport?.Client?.Code || '',
        }
      : {
          customReportName: `${activeCustomReport?.CustomReportName || ''} (Copy)`,
          filterName: sourceFilterType,
          startDate: '',
          endDate: '',
          campaigns: (activeCustomReport?.Filters?.[0]?.filter?.list as string[]) || [],
          clientCode: activeCustomReport?.Client?.Code || '',
        };

  const [values, setValues] = useState<CampaignPeriodValues>(initialValues);
  const [summaryToast, setSummaryToast] = useState(false);
  const [isDuplicating, setIsDuplicating] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [validationError, setValidationError] = useState<string | null>(null);
  const [duplicateProgress, setDuplicateProgress] = useState({ current: 0, total: 0, message: '' });
  const [duplicateResult, setDuplicateResult] = useState<{
    success: boolean;
    sectionsCreated: number;
    elementsCreated: number;
    warnings: string[];
  } | null>(null);

  // Hooks
  const [saveNewSection] = useSaveNewSection();
  const [saveNewSectionItem] = useSaveNewSectionItem();
  const [fetchCustomReportSections] = useGetCustomReportSections();
  const [getSavedText] = useGetSavedText();
  const [saveText] = useSaveCustomReportText();
  const [getKPIValues] = useGetKPIValues();
  const [saveKPI] = useSaveCustomReportKPI();
  const [getStoredQuery] = useGetStoredQuery();
  const [saveQuery] = useSaveCustomReportQuery();
  const [duplicateQuery] = useDuplicateQuery();
  const [getStoredFile] = useGetStoredFile();
  const [getStoredCreative] = useGetStoredCreativeByReportId();
  const [saveCreative] = useSaveCustomReportCreativeForDuplication();

  const handleSelectChangeAndUpdateGlobal = (selectedOption: any, accessorKey: string) => {
    const value = selectedOption ? (selectedOption.label ? selectedOption.label : selectedOption) : '';
    setValues({
      ...values,
      [accessorKey]: value,
    });
  };

  const campaignsWithSelectedClient = permanentCampaignList
    ?.filter((campaign) => campaign?.ClientCode === values.clientCode)
    .map((campaign) => ({ value: campaign?.campaignId, label: `${campaign?.campaign} (${campaign?.campaignId})` }));

  // Retry helper - tries operation twice
  const withRetry = async <T,>(
    operation: () => Promise<T>,
    operationName: string,
  ): Promise<{ success: boolean; result?: T; error?: string }> => {
    for (let attempt = 1; attempt <= 2; attempt++) {
      try {
        const result = await operation();
        return { success: true, result };
      } catch (e) {
        console.warn(`${operationName} - Attempt ${attempt} failed:`, e);
        if (attempt === 2) {
          return { success: false, error: `${operationName} failed after 2 attempts` };
        }
        // Wait a bit before retry
        await new Promise((resolve) => setTimeout(resolve, 500));
      }
    }
    return { success: false, error: `${operationName} failed` };
  };

  // Main duplication logic
  const duplicateReport = async (newReportId: number, queryFilters: DuplicateQueryFilters) => {
    const warnings: string[] = [];
    let sectionsCreated = 0;
    let elementsCreated = 0;

    const clientInfo = {
      code: values.clientCode || '',
      country: reducedClientList?.find((c) => c?.ClientCode === values.clientCode)?.ClientCountry || '',
    };

    // Get all sections from source report
    const sourceSections = sectionLayoutState || [];
    const totalSections = sourceSections.length;

    setDuplicateProgress({ current: 0, total: totalSections, message: 'Starting duplication...' });

    for (let sectionIndex = 0; sectionIndex < sourceSections.length; sectionIndex++) {
      const section = sourceSections[sectionIndex];
      setDuplicateProgress({
        current: sectionIndex + 1,
        total: totalSections,
        message: `Duplicating section ${sectionIndex + 1}/${totalSections}...`,
      });

      // Step 1: Create section in new report
      const sectionLayout = {
        i: (sectionIndex + 1).toString(),
        x: section.SectionPosition?.x ?? 0,
        y: section.SectionPosition?.y ?? 0,
        w: section.SectionPosition?.w ?? 1,
        h: section.SectionPosition?.h ?? 1,
      };

      const createSectionResult = await withRetry(
        () => saveNewSection(sectionIndex + 1, sectionLayout, newReportId),
        `Create section ${sectionIndex + 1}`,
      );

      if (!createSectionResult.success || createSectionResult.result !== 'success') {
        warnings.push(`Failed to create section ${sectionIndex + 1}`);
        continue;
      }

      // Fetch the new section to get its ID
      const newSections = await fetchCustomReportSections(newReportId);
      const newSection = newSections?.find((s) => s.Position === sectionIndex + 1);

      if (!newSection?.SectionID) {
        warnings.push(`Could not find newly created section ${sectionIndex + 1}`);
        continue;
      }

      sectionsCreated++;

      // Step 2: Process elements in this section
      const elements = (section.SectionElements || []).filter(Boolean);

      for (const element of elements) {
        if (!element?.SectionItemID) continue;

        // Fetch content first
        const type = element.Type?.toUpperCase();
        let content: { type: string; data: any } | null = null;

        try {
          if (type === 'TEXT') {
            const text = await getSavedText(element.SectionItemID);
            content = { type: 'TEXT', data: text };
          } else if (type === 'KPI') {
            const kpiValues = await getKPIValues(element.SectionItemID);
            content = { type: 'KPI', data: kpiValues };
          } else if (type === 'TABLE' || type === 'CHART' || type === 'KPIQUERY') {
            const query = await getStoredQuery(element.SectionItemID);
            content = { type: 'QUERY', data: query };
          } else if (type === 'FILE') {
            const file = await getStoredFile(element.SectionItemID);
            content = file && file.name ? { type: 'FILE', data: file } : { type: 'FILE', data: null };
          } else if (type === 'CREATIVE') {
            const creativeData = await getStoredCreative(
              element.SectionItemID,
              activeCustomReport?.CustomReportID as number,
            );
            content = creativeData ? { type: 'CREATIVE', data: creativeData } : null;
          }
        } catch (e) {
          console.warn(`Failed to fetch content for element ${element.SectionItemID}:`, e);
        }

        // Create element structure
        const itemLayout = {
          Position: element.Position || 0,
          GridPosition: {
            i: element.GridPosition?.i || '',
            x: element.GridPosition?.x || 0,
            y: element.GridPosition?.y || 0,
            w: element.GridPosition?.w || 1,
            h: element.GridPosition?.h || 1,
          },
          Type: element.Type || '',
          HasData: content?.data ? true : false,
          Open: false,
        };

        const createItemResult = await withRetry(
          () => saveNewSectionItem(newSection.SectionID!, itemLayout, newReportId),
          `Create element in section ${sectionIndex + 1}`,
        );

        if (!createItemResult.success || createItemResult.result?.status !== 200) {
          warnings.push(`Failed to create element in section ${sectionIndex + 1}`);
          continue;
        }

        const newItemId = createItemResult.result?.id;
        if (!newItemId) {
          warnings.push(`No ID returned for element in section ${sectionIndex + 1}`);
          continue;
        }

        elementsCreated++;

        // Copy content
        if (content?.data) {
          try {
            if (content.type === 'TEXT' && typeof content.data === 'string') {
              const saveResult = await withRetry(
                () => saveText(newItemId, content!.data, newReportId, clientInfo),
                'Save text',
              );
              if (!saveResult.success) warnings.push(`Failed to copy text content`);
            } else if (content.type === 'KPI' && Array.isArray(content.data) && content.data.length > 0) {
              const latestKPI = content.data[0];
              if (latestKPI) {
                const saveResult = await withRetry(
                  () =>
                    saveKPI(
                      newItemId,
                      {
                        value: latestKPI.floatValue ?? 0,
                        labelTitle: latestKPI.label ?? '',
                        labelSubtitle: latestKPI.subtitle ?? '',
                        valueFormat: latestKPI.format ?? 'number',
                      },
                      newReportId,
                    ),
                  'Save KPI',
                );
                if (!saveResult.success) warnings.push(`Failed to copy KPI content`);
              }
            } else if (content.type === 'QUERY' && content.data) {
              const queryData = content.data as UserQuery;
              const metricsToSave =
                queryData.metrics
                  ?.filter((m): m is NonNullable<typeof m> => m !== null)
                  .map((m) => ({
                    chartType: m.chartType,
                    metric: m.metric,
                    axis: m.axis,
                  })) || undefined;

              // Duplicate query_id with updated filters
              let newQueryId = '';
              let newQueryIdCc = '';

              if (queryData.query_id) {
                const duplicatedId = await withRetry(
                  () => duplicateQuery(queryData.query_id!, queryFilters),
                  'Duplicate main query',
                );
                if (duplicatedId.success && duplicatedId.result) {
                  newQueryId = duplicatedId.result;
                } else {
                  warnings.push(`Failed to duplicate main query - using original reference`);
                  newQueryId = queryData.query_id || '';
                }
              }

              if (queryData.query_id_cc) {
                const duplicatedIdCc = await withRetry(
                  () => duplicateQuery(queryData.query_id_cc!, queryFilters),
                  'Duplicate CC query',
                );
                if (duplicatedIdCc.success && duplicatedIdCc.result) {
                  newQueryIdCc = duplicatedIdCc.result;
                } else {
                  warnings.push(`Failed to duplicate CC query - using original reference`);
                  newQueryIdCc = queryData.query_id_cc || '';
                }
              }

              const saveResult = await withRetry(
                () =>
                  saveQuery(
                    newItemId,
                    newQueryId,
                    newQueryIdCc,
                    queryData.title || '',
                    metricsToSave,
                    queryData.query_id_benchmark || undefined,
                    queryData.hideTotal ?? undefined,
                    newReportId,
                  ),
                'Save query',
              );
              if (!saveResult.success) warnings.push(`Failed to save query content`);
            } else if (content.type === 'FILE' && content.data instanceof File) {
              try {
                await saveFiletoS3(
                  content.data,
                  newItemId,
                  newReportId,
                  clientInfo.code,
                  clientInfo.country,
                  getEnvironment,
                  'CustomReports',
                );
              } catch (e) {
                warnings.push(`Failed to copy file content`);
              }
            } else if (content.type === 'CREATIVE' && content.data) {
              const creativeData = content.data;
              const creative = creativeData.creative;

              if (creative) {
                const creativeInput = {
                  id: creative.id || '',
                  position: creative.position ?? 0,
                  creativeOutputLocation: creative.creativeOutputLocation || '',
                  creativeID: creative.creativeID || '',
                  creativeName: creative.creativeName || '',
                  metrics:
                    creative.metrics
                      ?.filter((m: any): m is NonNullable<typeof m> => m !== null)
                      .map((m: any) => ({
                        label: m.label || '',
                        column: m.column || '',
                        decimals: m.decimals ?? 2,
                      })) || [],
                };

                const saveResult = await withRetry(
                  () =>
                    saveCreative(
                      newItemId,
                      creativeData.dataSourceName || '',
                      [creativeInput],
                      newReportId,
                      creativeData.title || undefined,
                    ),
                  'Save creative',
                );
                if (!saveResult.success) warnings.push(`Failed to copy creative content`);
              }
            }
          } catch (e) {
            console.warn(`Failed to copy content for element ${newItemId}:`, e);
          }
        }
      }
    }

    return { sectionsCreated, elementsCreated, warnings };
  };

  const handleSubmitClick = async () => {
    setIsDuplicating(true);
    setDuplicateProgress({ current: 0, total: 0, message: 'Creating new report...' });

    // Build filters for the new report (using same logic as getQueryFilters)
    let filters: any;
    if (values.filterName === 'date') {
      filters = {
        column: 'date',
        filter: {
          filtertype: filtertype.BETWEEN,
          datatype: datatype.DATE,
          from: values.startDate,
          to: values.endDate,
        },
      };
    } else {
      // Use NUMBER datatype and appropriate filtertype based on campaign count (same as getQueryFilters)
      const campaigns = values.campaigns || [];
      filters =
        // campaigns.length > 1
        //   ?
        {
          column: 'campaign_id',
          filter: {
            filtertype: filtertype.IN,
            datatype: datatype.NUMBER,
            list: campaigns,
          },
        };
      // : {
      //     column: 'campaign_id',
      //     filter: {
      //       filtertype: filtertype.EQUAL,
      //       datatype: datatype.NUMBER,
      //       value: campaigns[0],
      //     },
      //   };
    }

    // Get client info for date-based reports (needed to fetch campaigns in date range)
    const selectedClientCountry = reducedClientList?.find(
      (client) => client?.ClientCode === values.clientCode,
    )?.ClientCountry;

    // Build query filters for duplicating queries
    const queryFilters: DuplicateQueryFilters =
      values.filterName === 'date'
        ? {
            filterType: 'date',
            startDate: values.startDate,
            endDate: values.endDate,
            // Include client info so useDuplicateQuery can fetch campaigns in date range
            clientCode: values.clientCode,
            clientCountry: selectedClientCountry,
          }
        : {
            filterType: 'campaigns',
            campaignIds: values.campaigns,
          };

    try {
      // Step 1: Create the new report
      const response = (await API.graphql({
        query: saveCustomReport,
        variables: {
          Client: {
            Country: selectedClientCountry,
            Code: values.clientCode,
          },
          CustomReportName: values.customReportName,
          Filters: [filters],
        } as SaveCustomReportMutationVariables,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: SaveCustomReportMutation };

      if (!response.data.saveCustomReport) {
        throw new Error('Failed to create new report');
      }

      const newReportId = response.data.saveCustomReport;

      // Log activity
      logActivity({
        action: 'DUPLICATE_CUSTOM_REPORT',
      }).catch(console.error);

      // Step 2: Duplicate all sections and content with updated query filters
      const result = await duplicateReport(newReportId, queryFilters);

      setDuplicateResult({
        success: true,
        sectionsCreated: result.sectionsCreated,
        elementsCreated: result.elementsCreated,
        warnings: result.warnings,
      });

      setDuplicateProgress({ current: 0, total: 0, message: 'Duplication complete!' });

      // Show result for 2 seconds then navigate to new report
      setTimeout(() => {
        setDuplicateModal(false);
        setCustomReportId(newReportId.toString());
        window.location.reload();
      }, 2000);
    } catch (e) {
      console.error('Error duplicating report:', e);
      setDuplicateResult({
        success: false,
        sectionsCreated: 0,
        elementsCreated: 0,
        warnings: ['Failed to create new report'],
      });
      setIsDuplicating(false);
    }
  };

  // Validation
  const validateForm = () => {
    setValidationError(null);
    if (values.customReportName === '') {
      setValidationError('Please enter a custom report name');
      return false;
    }
    if (!values.clientCode) {
      setValidationError('Please select a client');
      return false;
    }
    if (values.filterName === 'date') {
      if (!values.startDate || !values.endDate) {
        setValidationError('Please select start and end date');
        return false;
      }
    } else if (values.filterName === 'campaigns') {
      if (!values.campaigns || values.campaigns.length === 0) {
        setValidationError('Please select at least one campaign');
        return false;
      }
    }
    return true;
  };

  // Async validation for date-based reports to check if campaigns exist in the period
  const validateAndProceed = async () => {
    if (!validateForm()) {
      return;
    }

    // For date-based filter, check if there are campaigns in the period
    if (values.filterName === 'date') {
      setIsValidating(true);
      setValidationError(null);
      try {
        const selectedClientCountry = reducedClientList?.find(
          (client) => client?.ClientCode === values.clientCode,
        )?.ClientCountry;

        const campaigns = await fetchCampaignsInDateRange(
          values.clientCode || '',
          selectedClientCountry || '',
          values.startDate,
          values.endDate,
        );

        if (!campaigns || campaigns.length === 0) {
          setValidationError('No campaigns found in the selected period. Please change the date range.');
          setIsValidating(false);
          return;
        }
      } catch (error) {
        console.error('Error validating campaign period:', error);
        setValidationError('Error checking campaigns. Please try again.');
        setIsValidating(false);
        return;
      }
      setIsValidating(false);
    }

    // Validation passed, show summary
    setSummaryToast(true);
  };

  return (
    <Modal style={{ zIndex: 1000 }}>
      <HeadModul style={{ height: 'fit-content', position: 'relative' }}>
        {isDuplicating && (
          <DuplicatingOverlay>
            <ReactLoading type="spinningBubbles" color={theme.publishButton} width={60} height={60} />
            <div className="progress-text">{duplicateProgress.message}</div>
            {duplicateProgress.total > 0 && (
              <div className="progress-detail">
                Section {duplicateProgress.current} of {duplicateProgress.total}
              </div>
            )}
            {duplicateResult && (
              <div style={{ marginTop: '16px', textAlign: 'center' }}>
                <div style={{ color: duplicateResult.success ? '#4CAF50' : '#f44336', fontWeight: 'bold' }}>
                  {duplicateResult.success ? '✓ Duplication Complete!' : '✗ Duplication Failed'}
                </div>
                {duplicateResult.success && (
                  <div style={{ marginTop: '8px', fontSize: '12px' }}>
                    {duplicateResult.sectionsCreated} sections, {duplicateResult.elementsCreated} elements copied
                    {duplicateResult.warnings.length > 0 && (
                      <div style={{ color: '#ff9800', marginTop: '4px' }}>
                        {duplicateResult.warnings.length} warning(s)
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </DuplicatingOverlay>
        )}

        <button type="button" className="x" onClick={() => setDuplicateModal(false)} disabled={isDuplicating}>
          <IoMdClose className="closeIcon" />
        </button>

        <h1>Duplicate Custom Report</h1>
        {!summaryToast ? (
          <ModulContainer>
            <FormInputContainer>
              <label htmlFor="customReportName">Custom Report Name</label>
              <input
                type="text"
                id="customReportName"
                name="customReportName"
                placeholder="Enter custom report name"
                style={{ width: '100%', padding: '0.5rem' }}
                value={values['customReportName'] || ''}
                onChange={(e) => handleSelectChangeAndUpdateGlobal(e.target.value, 'customReportName')}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="none"
                spellCheck="false"
              />
            </FormInputContainer>

            {/* Client Code selection disabled - using source report's client
            <FormInputContainer>
              <label htmlFor="clientCode">Client Code</label>
              <select
                id="clientCode"
                name="clientCode"
                style={{ width: '100%', padding: '0.5rem' }}
                value={values['clientCode'] || ''}
                onChange={(e) => handleSelectChangeAndUpdateGlobal(e.target.value, 'clientCode')}
              >
                <option disabled hidden value=""></option>
                {reducedClientList?.map((client) => (
                  <option key={client?.ClientCode} value={client?.ClientCode}>
                    {client?.ClientCode} {client?.ClientCountry} ({client?.ClientName})
                  </option>
                ))}
              </select>
            </FormInputContainer>
            */}

            <FormInputContainer>
              <label htmlFor="">Create Custom Report based on Date or Campaigns</label>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '1vw' }}>
                <StyledLabel>
                  <input
                    className="inputCircle"
                    type="radio"
                    name="filterName"
                    value={'date'}
                    checked={values.filterName === 'date'}
                    onChange={(e) => handleSelectChangeAndUpdateGlobal(e.target.value, 'filterName')}
                  />
                  <span className="checked">Date period</span>
                </StyledLabel>

                <StyledLabel>
                  <input
                    className="inputCircle"
                    type="radio"
                    name="filterName"
                    value={'campaigns'}
                    checked={values.filterName === 'campaigns'}
                    onChange={(e) => handleSelectChangeAndUpdateGlobal(e.target.value, 'filterName')}
                  />
                  <span className="checked">Campaign list</span>
                </StyledLabel>
              </div>

              {values.filterName === 'date' && (
                <FilterTypeContainer>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: '3vw' }}>
                    <FormInputContainer style={{ width: 'fit-content' }}>
                      <label htmlFor="startDate">Start Date</label>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={values['startDate'] ? new Date(values['startDate']) : null}
                        onChange={(selectedOption: any) =>
                          handleSelectChangeAndUpdateGlobal(
                            selectedOption?.toISOString().slice(0, 10) || '',
                            'startDate',
                          )
                        }
                        calendarStartDay={1}
                        minDate={getStartDate()}
                        maxDate={getEndDate()}
                      />
                    </FormInputContainer>
                    <FormInputContainer style={{ width: 'fit-content' }}>
                      <label htmlFor="endDate">End Date</label>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={values['endDate'] ? new Date(values['endDate']) : null}
                        onChange={(selectedOption: any) =>
                          handleSelectChangeAndUpdateGlobal(selectedOption?.toISOString().slice(0, 10) || '', 'endDate')
                        }
                        calendarStartDay={1}
                        minDate={getStartDate()}
                        maxDate={getEndDate()}
                      />
                    </FormInputContainer>
                  </div>
                </FilterTypeContainer>
              )}
              {values.filterName === 'campaigns' && (
                <FilterTypeContainer>
                  <FormInputContainer>
                    <label htmlFor="campaigns">Campaigns</label>
                    <SubContainer style={{ padding: '0.5rem', width: '90%' }}>
                      <CustomSelect
                        className="styleToFit"
                        placeholder={
                          !values.clientCode || campaignsWithSelectedClient?.length === 0
                            ? 'Select Client First'
                            : 'Select Campaign(s)'
                        }
                        isMulti
                        value={values.campaigns?.map((campaign) => ({ value: campaign, label: campaign })) || []}
                        options={campaignsWithSelectedClient}
                        onChange={(selectedOption: any) => {
                          const selectedValues = selectedOption.map((option: any) => option.value);
                          handleSelectChangeAndUpdateGlobal(selectedValues, 'campaigns');
                        }}
                        isDisabled={!values.clientCode || campaignsWithSelectedClient?.length === 0}
                      ></CustomSelect>
                    </SubContainer>
                  </FormInputContainer>
                </FilterTypeContainer>
              )}
            </FormInputContainer>

            {/* Validation Error Message */}
            {validationError && (
              <div
                style={{
                  padding: '1rem',
                  borderRadius: '4px',
                  margin: '1rem 0',
                  backgroundColor: '#f8d7da',
                  color: '#721c24',
                  border: '1px solid #f5c6cb',
                  textAlign: 'center',
                }}
              >
                {validationError}
              </div>
            )}

            <div className="buttonsContainer" style={{ alignSelf: 'center' }}>
              <button style={{ marginRight: '.4vw' }} type="button" onClick={() => setDuplicateModal(false)}>
                Cancel
              </button>
              <DarkButton type="button" disabled={isValidating} onClick={() => validateAndProceed()}>
                {isValidating ? 'Checking...' : 'Duplicate'}
              </DarkButton>
            </div>
          </ModulContainer>
        ) : (
          <ModulContainer>
            <SingleColumn style={{ width: '100%', padding: '1.5rem' }}>
              <h1 style={{ fontSize: '1.2vw' }}>Summary</h1>
              <h1 style={{ marginBottom: '1rem', fontSize: '16px', textAlign: 'left' }}>
                <strong>Custom Report Name:</strong> {values.customReportName || 'N/A'}
              </h1>
              <h1 style={{ marginBottom: '1rem', fontSize: '16px', textAlign: 'left' }}>
                <strong>Client Code:</strong> {values.clientCode || 'N/A'}
              </h1>
              {values.filterName === 'date' ? (
                <h1 style={{ marginBottom: '1rem', fontSize: '16px', textAlign: 'left' }}>
                  <strong>Date Period:</strong>
                  <div style={{ display: 'flex', gap: '2rem', marginTop: '0.5rem' }}>
                    <div>
                      <label style={{ fontWeight: 'bold', display: 'block' }}>Start Date:</label>
                      {values.startDate || 'N/A'}
                    </div>
                    <div>
                      <label style={{ fontWeight: 'bold', display: 'block' }}>End Date:</label>
                      {values.endDate || 'N/A'}
                    </div>
                  </div>
                </h1>
              ) : (
                <h1 style={{ marginBottom: '1rem', fontSize: '16px', textAlign: 'left' }}>
                  <strong>Campaigns:</strong>
                  <div style={{ marginTop: '0.5rem' }}>
                    {values.campaigns && values.campaigns.length > 0
                      ? values.campaigns.map((campaign) => (
                          <span key={campaign} style={{ display: 'block' }}>
                            {campaign}
                          </span>
                        ))
                      : 'N/A'}
                  </div>
                </h1>
              )}
              <h1 style={{ marginBottom: '1rem', fontSize: '16px', textAlign: 'left', marginTop: '1rem' }}>
                <strong>Sections to duplicate:</strong> {sectionLayoutState?.length || 0}
              </h1>
            </SingleColumn>
            <div className="buttonsContainer" style={{ alignSelf: 'center', marginTop: '2rem' }}>
              <button style={{ marginRight: '.4vw' }} type="button" onClick={() => setSummaryToast(false)}>
                Edit
              </button>
              <DarkButton type="button" onClick={() => handleSubmitClick()}>
                Confirm & Duplicate
              </DarkButton>
            </div>
          </ModulContainer>
        )}
      </HeadModul>
    </Modal>
  );
};

export default DuplicateCustomReportModal;
